import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-panel-footer',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-panel__actions{display:flex;justify-content:flex-start;align-items:center;padding:0 20px;height:60px;margin-top:-1px}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
  readonly PANEL_FOOTER_CLASS = 'mcrai-panel__footer';

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.PANEL_FOOTER_CLASS);
  }
}
